// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"7a0a294e","453":"6ae337d6","656":"3a38826e","805":"b7627d53","874":"ae0ec17e"}[chunkId] + ".chunk.js";
};